import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import fetchBase from './internal/_fetchBase';
import { isPlainObject, isPlainObjectOrArray, obj2query } from './utils';
import { Cookie } from '@ysf/helper';
var initOption = {
  method: 'GET',
  params: {},
  data: {},
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  responseType: 'JSON',
  credentials: 'include',
  // 默认带cookie
  csrfToken: true,
  // 默认传token
  // cache: 'no-cache',
  timeout: 25000 // 请求超时时间
};

/**
 * @description 基于fetch的请求
 * @param {string} url api 地址
 * @param {object} [option] 配置参数
 * @param {string} [option.method='GET'] 请求方式
 * @param {object} [option.params] 请求参数
 * @param {object} [option.data] 请求体
 * @param {object} [option.headers] 请求头，如：Content-Type:'application/json'
 * @param {string} [option.responseType='JSON'] 响应的数据类型
 * @param {string} [option.credentials='include'] 跨域请求
 * @param {string} [option.csrfToken=true] 传参是否包括token
 * @param {string} [option.timeout=25000] 请求超时时间
 * @return {Promise} 请求结果
 */

var fetch = function fetch(url, option) {
  // URL格式校验
  if (typeof url !== 'string') throw new Error(url + " is not an string!");
  var config = Object.assign({}, initOption, option || {});
  var _config$method = config.method,
    method = _config$method === void 0 ? 'GET' : _config$method,
    _config$params = config.params,
    params = _config$params === void 0 ? {} : _config$params,
    _config$data = config.data,
    data = _config$data === void 0 ? {} : _config$data,
    _config$headers = config.headers,
    headers = _config$headers === void 0 ? {} : _config$headers,
    _config$csrfToken = config.csrfToken,
    csrfToken = _config$csrfToken === void 0 ? true : _config$csrfToken;

  // 开发环境下增加code参数（企业域名），解决本地代理时后端无法识别企业域名的问题
  // if (process.env.NODE_ENV === 'development') {
  //   const code = location.hostname.split('.')[0];
  //   query = Object.assign({}, query, { code });
  // }

  // 处理请求的Url
  var getUrl = function getUrl() {
    // token从params拿，拿不到从cookie兜底
    var token = params.token || Cookie.get('__csrfToken') || '';
    // 对params参数进行处理
    var query = csrfToken ? _extends({}, params, {
      token: token
    }) : _extends({}, params);
    // 判断当前url中是否有问号，如果有就用&，如果没有就用问号，作为拼接参数的连接符
    var ask = url.includes('?') ? '&' : '?';
    // 如果params有参数，url后加问号
    if (!!query && Object.keys(query).length > 0) {
      // 把所有params参数添加到url中
      url += "" + ask + obj2query(query);
    }
    return url;
  };

  // 处理url请求参数
  if (/^(GET|DELETE|HEAD|OPTIONS|TRACE)$/i.test(method)) {
    if (!isPlainObject(params)) throw new Error('invalid params parameters!');
    if (isPlainObjectOrArray(data) && Object.keys(data).length && !Object.keys(params).length) {
      throw new Error('invalid content type!');
    }
    url = getUrl();
  }
  delete config.params;

  // 处理请求主体的数据格式
  var body;
  if (/^(POST|PUT|PATCH)$/i.test(method)) {
    if (!isPlainObjectOrArray(data)) throw new Error('invalid data parameters!');
    var contentType = headers['Content-Type'] || 'application/json';
    switch (contentType) {
      case 'application/x-www-form-urlencoded':
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        body = obj2query(data);
        break;
      case 'application/json':
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(data);
        break;
      // case 'multipart/form-data': // formData
      //   body = new FormData();
      //   Object.keys(data).forEach(key => {
      //     body.append(key, data[key]);
      //   });
      //   break;
      default:
        break;
    }
    config.body = body || data; // body没有的话，data兜底
    url = getUrl();
  }
  return fetchBase(url, config);
};
export default fetch;